import { ContainerComponent, wrap } from 'AppReact';
import Controller from './controller';
import {
  FlexCenterWrapper, WhiteSpaceNoWrap, Mr3, Mb2,
  GenericWrapper, FitRelativeWrapper, AbsoluteLeftTopWrapper,
  CustomBorderWrapper, FlexCenterBetweenWrapper, Px6, Mt4, Py2,
  CustomHeight, FullWIdthColumnScrollWrapper, My1, FlexBoxWrapper,
  FlexCenterJustifyCenterWrapper, CursorPointerWrapper, Mr2, My2
} from 'wrappers';
import internalState from './internalState';
import {
  SecondaryTextXs400, BorderlessInput, Icon, SecondaryTextXs,
  SecondaryTextSm, SecondaryTextSmBold
} from 'atoms';
import { MagnifyingGlassSvg, DownCaretSvg } from 'components/icons';
import { TextButton, DropdownRow, Count } from 'molecules';
import { escapedRegex } from 'utils';
import { textEllipsis } from 'utils/ellipsis';

export const definition = {
  name: 'SubscriptionHeaderFilter',
  controller: Controller,
  initialProps: ({ options, selectedOptionIds, label, isReadonly, singleSelect, placeholder, width, icon, bold, ellipsis }) => ({ options, selectedOptionIds, label, isReadonly, singleSelect, placeholder, width, icon, bold, ellipsis }),
  props: internalState,
  elements: [
    {
      wrapper: FitRelativeWrapper,
      name: 'Wrapper',
      ref: ({ containerRef }) => containerRef,
      elements: [
        {
          wrapper: wrap(FlexCenterWrapper, CursorPointerWrapper),
          name: 'Header',
          isButton: true,
          displayState: ({ isReadonly, selectedOptionIds, isOpen }) => ({ disabled: isReadonly, completed: selectedOptionIds.length > 0 && !isOpen }),
          bindings: ({ isOpen, isReadonly, selectedOptionIds, containerRef, inputRef }) => ({ isOpen, containerRef, isReadonly, inputRef, selectedOptionIds }),
          elements: [
            {
              component: wrap(Icon, Mr2),
              name: 'Icon',
              renderIf: ({ icon }) => !!icon,
              displayValue: ({ icon }) => icon,
            },
            {
              component: wrap(wrap(wrap(SecondaryTextXs400, WhiteSpaceNoWrap), Mr3), My2),
              renderIf: ({ bold }) => !bold,
              displayValue: ({ label }) => label
            },
            {
              component: wrap(wrap(wrap(SecondaryTextSmBold, WhiteSpaceNoWrap), Mr3), My2),
              renderIf: ({ bold }) => bold,
              displayValue: ({ label }) => label
            },
            {
              wrapper: GenericWrapper,
              name: 'SearchWrapper',
              ref: ({ inputRef }) => inputRef ?? null,
              elements: [
                {
                  component: wrap(BorderlessInput, Mr3),
                  name: 'SearchInput',
                  renderIf: ({ isOpen }) => isOpen,
                  displayState: ({ }) => ({ width: '114px', minWidth: '114px' }),
                  bindings: ({ searchTerm, }) => ({ value: searchTerm, placeholder: "Search..." })
                },
              ]
            },
            {
              component: wrap(SecondaryTextSm, Mr2),
              name: 'Button',
              renderIf: ({ selectedOptionIds, isOpen, options }) => !isOpen && selectedOptionIds.length > 0 && options.find(o => o.id === selectedOptionIds[0])?.displayName,
              displayValue: ({ options, selectedOptionIds, ellipsis }) => textEllipsis(options.find(e => e.id === selectedOptionIds[0]).displayName ?? '', ellipsis ?? 15)
            },
            {
              component: wrap(SecondaryTextSm, Mr2),
              name: 'Button',
              renderIf: ({ selectedOptionIds, isOpen, placeholder }) => placeholder && !isOpen && selectedOptionIds.length === 0,
              displayValue: ({ placeholder }) => placeholder
            },
            {
              component: wrap(Icon, Mr2),
              name: 'Button',
              renderIf: ({ selectedOptionIds, isOpen, options }) => !isOpen && selectedOptionIds.length > 0 && !options.find(o => o.id === selectedOptionIds[0])?.displayName && options.find(o => o.id === selectedOptionIds[0])?.icon,
              displayValue: ({ options, selectedOptionIds }) => options.find(e => e.id === selectedOptionIds[0]).icon
            },
            {
              component: wrap(Count, Mr2),
              renderIf: ({ selectedOptionIds, singleSelect, isOpen }) => !singleSelect && selectedOptionIds.length > 1 && !isOpen,
              name: 'Count',
              bindings: ({ selectedOptionIds }) => ({ count: selectedOptionIds.length - 1 })
            },
            {
              component: Icon,
              name: 'Caret',
              displayValue: ({ isOpen }) => isOpen ? MagnifyingGlassSvg({ color: '#C2CCCE' }) : DownCaretSvg({ color: '#C2CCCE' })
            },
          ]
        },
        {
          wrapper: AbsoluteLeftTopWrapper,
          displayState: ({ }) => ({ top: '30px' }),
          renderIf: ({ isOpen }) => isOpen,
          name: 'DropdownWrapper',
          elements: [
            {
              wrapper: CustomBorderWrapper,
              name: 'BorderWrapper',
              displayState: ({ }) => ({ borderRadius: '8px', border: '1px solid #E3E3E3', background: '#FFFFFF' }),
              elements: [
                {
                  wrapper: wrap(wrap(wrap(FlexCenterBetweenWrapper, Px6), Mt4), Mb2),
                  name: 'ClearAllHeader',
                  renderIf: ({ singleSelect }) => !singleSelect,
                  elements: [
                    {
                      component: SecondaryTextXs,
                      name: 'SelectedText',
                      displayValue: ({ selectedOptionIds }) => `${selectedOptionIds.length ?? 0} Selected`
                    },
                    {
                      component: TextButton,
                      name: 'ClearAll',
                      bindings: ({ selectedOptionIds, options, searchTerm }) => ({ searchTerm, small: true, mobileSmall: true, selectedOptionIds, options, title: selectedOptionIds.length ?? 0 > 0 ? 'Clear all' : 'Select all' }),
                    }
                  ]
                },
                {
                  wrapper: CustomHeight,
                  name: 'ListWrapper',
                  displayState: ({ width }) => ({ maxHeight: 270, width: width ?? '300px', display: 'flex' }),
                  elements: [
                    {
                      wrapper: FullWIdthColumnScrollWrapper,
                      name: 'ListWrapper',
                      displayState: ({ }) => ({ flexGrow: 1, height: 'unset' }),
                      elements: [
                        {
                          component: wrap(DropdownRow, My1),
                          name: 'Option',
                          isListOf: { option: ({ options, pageNumber, searchTerm }) => options.filter(o => escapedRegex(searchTerm).test(o.displayName)).slice(0, pageNumber * 10) },
                          bindings: ({ option, selectedOptionIds, singleSelect }) => {
                            const isSelected = selectedOptionIds.includes(option.id);
                            return { icon: option.icon, image: option.image, id: option.id, isSelected, selectedOptionIds, singleSelect, text: option.displayName }
                          },
                          displayState: ({ option, selectedOptionIds }) => ({ isSelected: selectedOptionIds.includes(option.id) })
                        },
                        {
                          component: wrap(wrap(wrap(TextButton, FlexBoxWrapper), FlexCenterJustifyCenterWrapper), Py2),
                          name: 'LoadMore',
                          renderIf: ({ options, pageNumber, searchTerm }) => (pageNumber * 10) < options.filter(o => escapedRegex(searchTerm).test(o.displayName)).length,
                          bindings: ({ pageNumber }) => ({ title: 'Load More...', pageNumber })
                        }
                      ]
                    },
                  ]
                }
              ]
            }
          ]
        }

      ]
    }
  ]
};

export default ContainerComponent(definition)